import { useState, useEffect } from 'react'
import i18n from '../../../i18n'
import { bruktbilfinansieringAPI } from '../../../services/api'
import type { BruktbilfinansieringOverviewResponse } from '../../../types/bruktbilfinansiering'
import type { BruktbilfinansieringFilters } from './useBruktbilfinansiering'

export function useOverview(bankOrgNr: string, filters: BruktbilfinansieringFilters) {
  const [data, setData] = useState<BruktbilfinansieringOverviewResponse | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetch = async () => {
    setLoading(true)
    setError(null)
    try {
      const res = await bruktbilfinansieringAPI.getOverview(bankOrgNr, {
        start_date: filters.startDate,
        end_date: filters.endDate,
        dealer_postnummer: filters.dealerPostnummer ?? undefined,
        buyer_postnummer: filters.buyerPostnummer ?? undefined,
        varebil: filters.varebil,
        classes: filters.classes?.length ? filters.classes : undefined,
      })
      setData(res.data)
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : i18n.t('errors.unknown', { ns: 'bbf' })
      setError(msg)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    refetch()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bankOrgNr, filters.startDate, filters.endDate, filters.dealerPostnummer, filters.buyerPostnummer, filters.varebil, JSON.stringify(filters.classes)])

  return { data, loading, error, refetch }
}
